import { PrivateCacheChannel } from '@/realtime/channels/cache/private/privateCacheChannel';
// eslint-disable-next-line import/prefer-default-export
export class OrganisationPlanChannel extends PrivateCacheChannel {
    constructor(orgUuid) {
        super(`organisation_${orgUuid}_plan`);
    }
}
